import { getRemoteMicOrigin } from '~/modules/utils/remote-mic-origin';

/** The invite link for a room: the origin another device can reach this game on, plus the route
 * and `?room=<code>`. Usually the current origin, so a preview or self-hosted deployment keeps
 * working; a loopback origin - the desktop app, the dev server - resolves to a public one instead,
 * as no other device can reach it. See `~/modules/utils/remote-mic-origin`. Callable while
 * pre-rendering, where there is no `location`, and every caller renders again in the browser. */
export default function buildRoomLink(route: string, code: string) {
  const linkObject = new URL(getRemoteMicOrigin());
  linkObject.pathname = `${import.meta.env.BASE_URL}${route}`;
  linkObject.search = `room=${code}`;

  return linkObject.href;
}
